module.exports = __webpack_public_path__ + "img/sld_mfm_invs_9_dark.bf0d9d61.svg";